const DIRECTION_HORIZON = 'horizon';
const DIRECTION_VERTICAL = 'vertical';

class Scroller {
  constructor(prop = {}) {
    this.step = prop.step;
    this.direction = prop.direction || DIRECTION_HORIZON;
    this.distance = 0;
    this.timer = null;
  }

  handleMove(target, step) {
    const direction = this.direction === DIRECTION_HORIZON ? 'left' : 'top';
    this.distance = step;
    target.scrollTo({
      [direction]: step,
      behavior: 'smooth',
    });
  }

  getMaxScroll(target) {
    if (target) {
      return target.scrollWidth - target.clientWidth;
    }
    return 0;
  }

  toPrevStep(target, size) {
    this.timer && clearTimeout(this.timer);
    this.timer = setTimeout(() => {
      if (target && target.scrollTo) {
        let distance = this.distance - size;
        distance = distance < 0 ? 0 : distance;
        this.handleMove(target, distance);
      }
    }, 100);
  }

  toNextStep(target, size) {
    this.timer && clearTimeout(this.timer);
    this.timer = setTimeout(() => {
      if (target && target.scrollTo) {
        const maxScroll = this.getMaxScroll(target);
        let distance = this.distance + size;
        distance = distance > maxScroll ? maxScroll : distance;
        this.handleMove(target, distance);
      }
    }, 100);
}
}

export default Scroller;